import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { mastersEditAction, mastersSearchAction } from './actions/MastersActions';
import MastersForm from './MastersForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.singleMastersManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.singleMastersSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.singleMastersManagerUrl(),
        component: MastersForm,
    },
    {
        link: RoutingUtil.singleMastersSearch(),
        component: () => (
            <SearchContainerWithPermission
                // scope="master.product_manager.search"
                // editScope="master.product_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                queryParamsAsWhere
                reducer="MastersReducer"
                dataPath="search"
                editAction={mastersEditAction}
                redirectUrlOnEdit={RoutingUtil.singleMastersManagerUrl()}
                action={mastersSearchAction}
                // caseSensitiveSearchProperties={[
                //     'category',
                // ]}
                columns={{
                    masterType: {
                        display: 'Master Type',
                    },
                    masterName: {
                        display: 'Master Name',
                    },
                    active: {
                        display: 'Active',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                    },
                }}
            />
        ),
    },
];

const ProductContainer = () => (
    <CrudLayoutContainer
        title="Options Master"
        tabs={tabs}
        routes={routes}
    />
);

ProductContainer.propTypes = {

};

export default ProductContainer;
